"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Configuration;
/**
 * Configuration service
 * A simpler version of something like nconf where we want to merge
 * configuration from multiple sources in a predictable way.
 */
function Configuration(defaults, overrides) {
  var config = _extends({}, defaults, overrides);

  var service = {
    // eslint-disable-next-line no-prototype-builtins
    has: function has(key) {
      return config.hasOwnProperty(key);
    },
    get: function get(key) {
      if (!service.has(key)) {
        throw new Error("Cannot get unknown config key: " + key);
      }
      return config[key];
    }
  };

  return service;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/Config.js
// module id = 986
// module chunks = 0